import { get, replace, isString } from 'lodash'
import InfiniteScroll from '@/common/lib/vue-infinite-scroll-custom'
import scrollMonitor from 'scrollmonitor'
import { EventBus } from '@/components/eventbus/EventBus'
import store from '@/store'
import router from '@/router'
import { ON_DISPLAY } from '@/common/event.const'

export const progressBar = {
  inserted: (el, binding) => {
    const { value } = binding
    let resultValue = value >= 100 ? 100 : value
    el.style.width = resultValue + '%'
  }
}

const getBottomTagListEl = (tag) => {
  let className = ''
  let tagText = ''
  switch (tag) {
    case 'free':
      className = 'tag-free'
      tagText = '무료'
      break
    case 'dubbing' :
      className = 'tag-dubbing'
      tagText = '더빙'
      break
    case 'subtitle':
      className = 'tag-subtitle'
      tagText = '자막'
      break
    case 'disablepc':
      className = 'tag-disable-pc'
      tagText = 'PC불가'
      break
    case 'won':
      className = 'tag-won'
      tagText = '개별구매'
      break
    case 'playy':
      className = 'tag-playy'
      tagText = 'PLAYY'
      break
    default:
      className = ''
      tagText = ''
  }
  return `<span class="${className}">${tagText}</span>`
}

const getTopTagListEl = (tag) => {
  let className = ''
  let tagText = ''
  switch (tag) {
    case 'quickvod':
      className = 'tag-quick-vod'
      tagText = 'Quick VOD'
      break
    case 'playy':
      className = 'tag-playy'
      tagText = 'PLAYY'
      break
    case 'update':
      className = 'tag-update'
      tagText = '업데이트'
      break
    case 'discount':
      className = 'tag-discount'
      tagText = '할인'
      break
    case 'event':
      className = 'tag-event'
      tagText = '이벤트'
      break
    case 'payback':
      className = 'tag-payback'
      tagText = '페이백'
      break
    case 'reserve':
      className = 'tag-reserve'
      tagText = '예약구매'
      break
    case 'free':
      className = 'tag-free'
      tagText = '무료'
      break
    case 'drm':
      className = 'tag-drm'
      tagText = 'DRM'
      break
    case 'rent':
      className = 'tag-rent'
      tagText = '대여'
      break
    case 'disablepc':
      className = 'tag-disable-pc'
      tagText = 'PC불가'
      break
    case 'freevod' :
      className = 'tag-free-vod'
      tagText = '무료'
      break
    case 'subtitle':
      className = 'tag-subtitle'
      tagText = '자막'
      break
    case 'dubbing' :
      className = 'tag-dubbing'
      tagText = '더빙'
      break
    case 'won':
      className = 'tag-won'
      tagText = '개별구매'
      break
    default:
      className = ''
      tagText = ''
  }
  if (className === '' && tagText === '') {
    return ''
  } else {
    return `<span class="${className}">${tagText}</span>`
  }
}

export const bottomTagList = {
  inserted: (el, binding) => {
    const { value } = binding
    if (value === '') return
    el.innerHTML = value.map(getBottomTagListEl).join('')
  }
}

export const topTagList = {
  inserted: (el, binding) => {
    const { value } = binding
    let res = ''
    if (Array.isArray(value)) {
      res = value.map(getTopTagListEl).join('')
    }
    el.innerHTML = res
  }
}

export const ageTag = {
  update: (el, binding) => {
    const { value } = binding
    let res = ''
    if (Number(value) !== 0) {
      res = `<span class="tag-${value}">${value}</span>`
    }
    el.innerHTML = res
  }
}

// TODO: 하늘색 컬러값 변경
export const convertSpecialSymbols = (titleText) => {
  let text = titleText
  if (text.indexOf('@0@') > -1) {
    text = replace(text, '@0@', '<strong style="font-weight: 700;">')
    text = replace(text, '@^0@', '</strong>')
  }
  if (text.indexOf('@1@') > -1) {
    text = replace(text, '@1@', '<span style="color: #3887ff;">')
    text = replace(text, '@^1@', '</span>')
  }
  if (text.indexOf('@2@') > -1) {
    text = replace(text, '@2@', '<strong style="color: #3887ff; font-weight: 700;">')
    text = replace(text, '@^2@', '</strong>')
  }
  if (text.indexOf('@3@') > -1) {
    text = replace(text, '@3@', '<span style="color: #00bbec;">')
    text = replace(text, '@^3@', '</span>')
  }
  if (text.indexOf('@4@') > -1) {
    text = replace(text, '@4@', '<strong style="color: #00bbec; font-weight: 700;">')
    text = replace(text, '@^4@', '</strong>')
  }
  if (text.indexOf('@5@') > -1) {
    text = replace(text, '@5@', '<del>')
    text = replace(text, '@^5@', '</del>')
  }
  return text
}
const replaceAll = (str, search, replacement) => {
  let newStr = ''
  if (isString(str)) { // maybe add a lodash test? Will not handle numbers now.
    newStr = str.split(search).join(replacement)
  }
  return newStr
}
export const changeColorSearchWord = (text) => {
  const searchKeyword = store.getters.externalInputSearchKeyword
  if (searchKeyword.length > 0) {
    return replaceAll(text, searchKeyword, `<span style="color:#3887ff">${searchKeyword}</span>`)
  } else {
    return text
  }
}

export const bandTitle = {
  bind: (el) => {
    el.innerHTML = convertSpecialSymbols(el.innerHTML)
  }
}
export const specialSymbolsText = {
  bind: (el, binding) => {
    const { value } = binding
    el.innerHTML = convertSpecialSymbols(value)
  }
}

export const convertDot = {
  bind: (el, binding) => {
    const { value } = binding
    el.innerHTML = replace(value, /\$O\$/g, '<i class="icon-dotted"></i>')
  }
}

export const titleList = {
  bind: (el, binding) => {
    const isSearchView = router.app._route.name === 'search'
    const { titleList, sixweekholdback } = binding.value
    const isSixWeekHolderBack = sixweekholdback === 'y'
    let resTitleList = titleList.map((title, idx) => {
      let text = get(title, 'text', '')
      if (text === '') {
        return null
      }
      text = isSearchView ? changeColorSearchWord(text) : text
      if (text.indexOf('$O$') > -1) {
        text = replace(text, '$O$', '<i class="icon-dotted"></i>')
      }
      // let icon = get(title, 'icon', '')
      let maxLine = Number(get(title, 'maxline', '1'))
      if (title.text.indexOf('<br') > -1) {
        maxLine = 2
      }
      let titleClass = `title${idx + 1} line${maxLine}`
      return `<div class="cell-title"><span class="${titleClass}">${convertSpecialSymbols(text)}</span></div>`
    }).filter((title) => {
      return title !== null
    }).join('')
    if (isSixWeekHolderBack) {
      resTitleList = resTitleList.concat(`<div class="cell-title"><span class="week6">기본월정액 무료</span></div>`)
    }
    el.innerHTML = resTitleList
  }
}

export const directors = {
  bind: (el, binding) => {
    const { value } = binding
    const directors = value.list
    el.innerHTML = directors.map(({ text, value }) => {
      return `<span><a href="${value}">${text}</a></span>`
    }).join(', ')
  }
}
export const actors = {
  bind: (el, binding) => {
    const { value } = binding
    const actors = value.list.map((actor) => {
      if (typeof actor === 'string') return { text: actor, value: actor }
      else return actor
    }).map(({ text, value }) => {
      return `<span><a href="${value}">${text}</a></span>`
    }).join(', ')
    el.innerHTML = actors
  }
}

export const qualities = {
  bind: (el, binding) => {
    const { value } = binding
    const qualities = value.list || []
    el.innerHTML = qualities.filter((quality) => {
      return Number(quality.filesize.match(/\d+/g)[0]) !== 0
    }).map((quality, index) => {
      return `<span>${quality.name} ${quality.filesize}</span>${(index + 1) % 2 === 0 ? '</br>' : ' <i class="icon-dotted"></i> '}`
    }).join('')
  }
}

export const nextLineUpTitle = {
  inserted: (el, binding) => {
    const { value } = binding
    const title = get(value, ['liveepgschannellist', 'list', '0', 'title'], '')
    el.innerHTML = title
  }
}

export const nextLineUpPlayTime = {
  inserted: (el, binding) => {
    const { value } = binding
    const start = get(value, ['liveepgschannellist', 'list', '0', 'starttime'], '')
    const end = get(value, ['liveepgschannellist', 'list', '0', 'endtime'], '')
    el.innerHTML = '' + start.split(' ').pop() + ' ~ ' + end.split(' ').pop()
  }
}

export const keywordColor = {
  inserted: (el, binding) => {
    const { value } = binding
    let changeWord = `<strong>${value.keyword}</strong>`
    var re = new RegExp(value.keyword, 'g')
    if ((value.title && value.title.indexOf(value.keyword) >= 0) || (typeof word === 'object')) {
      el.innerHTML = value.title.replace(re, changeWord)
    } else {
      el.innerHTML = value.title
    }
  }
}

const elementWatcherMap = {}

export const onDisplay = {
  inserted (el, binding) {
    const { value } = binding
    const onDisplay = get(value, 'eventListPlainObjectList', []).filter(event => event.type === 'on-display')
    if (onDisplay === undefined) return
    const elementWatcher = scrollMonitor.create(el, 50)
    elementWatcherMap[value.title] = elementWatcher
    elementWatcher.enterViewport(function () {
      EventBus.$emit(ON_DISPLAY, onDisplay[0])
    })
  },
  unbind (el, binding) {
    const { value } = binding
    if (elementWatcherMap[value.title]) {
      elementWatcherMap[value.title].destroy()
    }
  }
}

export const infiniteScroll = InfiniteScroll
